export const URL = {
	HOME: '/',
	LOGIN: '/login',
	SIGNIN: '/signin',
	EQUIPMENT: '/equipment',
	TRAINING: '/training',
	CUSTOM: '/custom',
	CATALOG: '/catalog',
	FAQ: '/faq',
	CART: '/cart',
	SPAREPARTS: '/spare-parts',
	MYORDERS: '/my-orders',
	CONTACT: '/contacts',
	CHECKOUT: '/cart/checkout',
	SHIPPING: '/cart/shipping',
	BILLING: '/cart/billing',
	THANKYOU: '/thankyou',
	QUOTES: '/quotes',
	TERMS: 'https://www.valtech.com/legal-notices/',
	MANAGE: '/manage',
};

export const LABEL = {
	HOME: 'Home',
	LOGIN: 'Login',
	SIGNIN: 'Sign in',
	EQUIPMENT: 'My equipment',
	TRAINING: 'Training',
	CUSTOM: 'Custom training',
	CATALOG: 'Catalog',
	CART: 'My shopping cart',
	MYORDERS: 'My Orders',
	CONTACT: 'Contact',
	CHECKOUT: 'Checkout',
	SHIPPING: 'Shipping information',
	THANKYOU: 'Thank you',
	QUOTES: 'Quotes',
	TERMS: 'Terms and conditions',
	MANAGE: 'User admin',
};
